<template>
    <div>
        <div class="box" :value="value">
            <input type="checkbox" class="checker"
                   :id="id"
                   :name="name"
                   :value="value"
                   :checked="value"
                   v-on:change="onChangeEvent($event)"/>
            <label class="checkbox" :for="id"></label>
            <label :for="id" class="noselect label-style">{{labelText}}</label>
        </div>
    </div>
</template>

<script>
    export default {
        name: "BBtnCheckbox",
        props: {
            id: String,
            name: String,
            value: Boolean,
            labelText: String,
            // booleanValue: Boolean, // unnecessary value qingshuang
        },
        data() {
            return {
            }
        },

        watch:{
            'value'() {
                // console.info(this.value)
            }
        },

        methods: {
            onChangeEvent(event) {
                this.$emit("changed", event.target.checked);
                this.$emit("input", event.target.checked);
            },
        }
    }
</script>

<style scoped>
    .checker {
        padding-left: 0;
        display: none;
    }

    .checkbox {
        display: flex;
        width: 22px;
        height: 22px;
        background: #FFFFFF;
        border: 1px solid #0171A3;
        border-radius: 2px;
        align-items: center;
        justify-content: center;
    }

    .checker:checked + label::before {
        content: url("../assets/check-ok.png");
        zoom: 0.5;
        -ms-zoom: 0.5;
        -webkit-zoom: 0.5;
        -moz-transform: scale(0.5,0.5);
    }

    .box {
        display: flex;
        align-items: center;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }

    .label-style {
        margin: 0 10px;
        font-size: 14px;
        color: #333333;
    }
</style>